<template>
    <div class="site-list">
        <div class="save-state-loading" v-show="isLoading">
            <i></i>正在复制项目
        </div>
        <BlockTitle title="站点列表" iconf="console-icon icon-site2" v-if="!isToolSite"></BlockTitle>
        <div class="site-list-title">
            <el-button @click="yxyun()" v-if="isToolSite">
                <i class="el-icon-plus"></i> 新增站点
            </el-button>
			<template v-if="false">
				<div class="console" v-if="isNotice && !isToolSite" @click="openConsole">进入管理后台</div>
			</template>
            <ul>
                <li :class="titleType===0? 'is-active':''" @click="handleClick(0)">全部</li>
                <li :class="titleType===1? 'is-active':''" @click="handleClick(1)">PC网站</li>
                <li :class="titleType===2? 'is-active':''" @click="handleClick(2)">手机站</li>
            </ul>
        </div>
        <div class="site-list-main">
            <SiteListInit :siteType="titleType" v-if="isRouterAlive"></SiteListInit>
            <SiteListMain :siteType="titleType" v-if="isRouterAlive" @load="load"></SiteListMain>
        </div>
    </div>
</template>

<script>
import BlockTitle from '../member-component/BlockTitle'
import SiteListMain from './SiteListMain'
import SiteListInit from './SiteListInit'
import MemberApi from '@/api/member.api'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'site-list',
    components: {
        BlockTitle, SiteListMain, SiteListInit
    },
    data () {
        return {
            titleType: 0,
            isToolSite: false,
            isRouterAlive: true,
            isLoading: false,
            isLoadingCount: false,
			isNotice: false
        }
    },
    provide () {
        return {
            reload: this.reload
        }
    },
    computed: {
        ...mapGetters('user', ['userInfo']),
    },
    created () {
        this.titleType = Number(this.$route.query.siteType) || 0
        this.isToolSite = this.$route.name === 'tool_site'
		let token = this.$route.query.token
		if (token) this.isNotice = true
    },
    watch: {},
    methods: {
        ...mapActions('member', ['authorizeNewNSY']),
        reload () {
            this.isRouterAlive = false           //先关闭，
            this.$nextTick(function () {
                this.isRouterAlive = true         //再打开
            })
        },
        load (data) {
            this.isLoading = data
        },
        handleClick (row) {
            this.titleType = row
        },
        openUrl (url, type) {
            const routeData = this.$router.resolve({ path: url, params: { tblType: type } })
            window.open(routeData.href, '_blank')
        },
        whichToShow ({ key, ftpId }) {
            this.$parent.whichToShow({
                key,
                ftpId
            })
        },
        async yxyun () {

            // 站神购买页
            const parmas = {
                route: '/floor/Manager?goods_id=661&cat_id=216',
                type: '0',
            }
            const data = await this.authorizeNewNSY(parmas)
            if (data.isSuccess) {
                window.open(data.nswUrl)
            } else {
                this.$message.error('授权登陆失败')
            }
            // let { data } = await MemberApi.authorizeNswYun({ clientId: 'nswyun-client' })
            // if (data.isSuccess) {
            //     let url = `${data.data.nswyunUrl}&type=3&id=15`
            //     window.open(url)
            // } else {
            //     this.$message.error('授权登陆失败')
            // }
        },

		//进入控制台
		openConsole () {
			this.openSiteUrl('/tool/console')
		},
		openSiteUrl (url) {
			const routeData = this.$router.resolve({ path: url})
			window.open(routeData.href, '_blank')
		},

    },
}
</script>
<style lang='scss' scoped>
.site-list {
    padding-bottom: 30px;
    background: #fff;
    border-radius: 4px;
    margin-bottom: 20px;
    position: relative;
}
.save-state-loading {
    position: fixed;
    top: 60px;
    left: 50%;
    margin-left: -20px;
    font-size: 15px;
    line-height: 27px;
    background-color: #64b437;
    padding: 0 10px;
    border-radius: 3px;
    color: #fff;
    .state-bg {
        position: fixed;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
        z-index: 2000;
    }

    i {
        display: inline-block;
        vertical-align: sub;
        margin-right: 10px;
        background: url("../../../assets/images/nsw-side-bar-icon.png")
            no-repeat -348px -164px;
        height: 17px;
        width: 17px;
        -webkit-animation: spin 1s linear 1s 5 alternate;
        animation: spin 1s linear infinite;
    }
    @-webkit-keyframes spin {
        from {
            -webkit-transform: rotate(0deg);
        }
        to {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
}
.site-list-title {
    margin: 0 40px;
    position: relative;
	.console{position: absolute;right: 0;top: 0;width: 120px;height: 35px;line-height: 35px;font-size: 14px;color: #fff;text-align: center;background: $colorA;border-radius: 3px;cursor: pointer;z-index: 10;}
    ul {
        display: flex;
        border-bottom: 1px solid #c6cde6;
    }
    li {
        width: 104px;
        height: 37px;
        font-size: 12px;
        color: #8392a4;
        line-height: 36px;
        text-align: center;
        border: 1px solid #c6cde6;
        margin-right: -1px;
        margin-bottom: -1px;
        position: relative;
        z-index: 2;
        cursor: pointer;
        &.is-active {
            z-index: 22;
            border-color: $colorA;
            color: $colorA;
        }
    }
    .el-button {
        position: absolute;
        right: 1.4%;
        top: -4px;
        display: block;
        width: 118px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid $colorA;
        padding: 0;
        color: #fff;
        background: $colorA;
        i {
            font-size: 14px;
        }
        &:hover {
            color: #fff;
            background: $colorA;
        }
    }
}
.site-list-main {
    padding: 0 40px;
}

.site-item-experience {
    border-bottom: 0;
}
</style>
